module.exports = __webpack_public_path__ + "static/img/wave.20ce471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/wave.png
// module id = gncl
// module chunks = 0